module.exports = __webpack_public_path__ + "img/三爱海陵.png";